import htmr from "htmr";

import { Text, View } from "@ctv/shared-core/src";

import { ROMAN } from "../constants";
import { termsAndConditionsStyles as styles } from "../styles";
import { RomanTitleSection } from "../types";
import NumbersRenderer from "./NumbersRenderer";

type Props = {
  romanTitleSections?: RomanTitleSection[];
};

export function RomanTitlesRenderer(props: Props) {
  const { romanTitleSections } = props;

  if (!romanTitleSections || romanTitleSections.length === 0) {
    return null;
  }

  return (
    <>
      {romanTitleSections.map((romanTitleSection, index) => (
        <View key={index} row>
          <Text style={styles.list} variant="ui-small">
            {ROMAN[index].toUpperCase()}.
          </Text>
          <View spacing="m" flex gapSpacing>
            <Text style={styles.justify} variant="ui-small-bold">
              {htmr(romanTitleSection.title)}
            </Text>
            <NumbersRenderer
              numberSections={romanTitleSection.numberSections}
            />
          </View>
        </View>
      ))}
    </>
  );
}
